import callApi from '../../util/apiCaller';
import { getCartItems, getSubtotal, getTotalWeight } from '../Cart/CartActions';

import { addError } from '../Error/ErrorActions';

export const SET_SHIPPING_FEES = 'SET_SHIPPING_FEES';
export const REMOVE_SHIPPING_FEE = 'REMOVE_SHIPPING_FEE';


export function getShippingFeesRequest(refreshCache = false) {
    return dispatch => {
        return callApi(`shippingfees${refreshCache ? '?refreshCache=1' : ''}`).then(res => {
            res.shippingFees && dispatch(setShippingFees(res.shippingFees));
            return res.shippingFees;
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

export function editShippingFeeRequest(shippingFee) {
    return dispatch => {
        return callApi('shippingfee/edit', 'post', { shippingFee }).then(res => {
            dispatch(getShippingFeesRequest(true));
            return res.shippingFee;
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

export function removeShippingFeeRequest(shippingFeeId) {
    return dispatch => {
        return callApi('shippingfee/remove', 'delete', { shippingFee: { _id: shippingFeeId } }).then(res => {
            dispatch(removeShippingFee(shippingFeeId));
            return res.ok;
        }).catch(error => {
            dispatch(addError(error));
            return null;
        });
    };
}

// Getters
export function getShippingFees(store) {
    return store.shippingFees.data;
}

export function getShippingFeeByAddress(store, address, escapeConditions = false) {
    return address && store.shippingFees.data.find(shippingFee => isShippingFeeApplicable(shippingFee, address, getCartItems(store), escapeConditions));
}

export function isShippingFeeApplicable(shippingFee, address, items = [], escapeConditions = false) {
    return shippingFee.countries.includes(address.countryCode)
        && (
            !shippingFee.exclude
            || (
                !address.postalCode
                || !shippingFee.exclude.postalCodes
                || shippingFee.exclude.postalCodes.split(',').every(postalCode => isAddressDepartmentAvailableForShippingFee(address.postalCode, postalCode))
            )
        ) && (
            escapeConditions
            || (shippingFee.conditions || []).every(condition => isConditionChecked(condition, items))
        );
}

export function isConditionPercentValue(condition) {
    return ((condition || {}).value || '').indexOf('%') !== -1;
}

export function getConditionValue(condition) {
    let conditionValue = parseFloat(condition.value);
    if(isConditionPercentValue(condition)) {
        conditionValue = parseFloat(condition.value.replace('%', ''));
    }
    return conditionValue;
}

export function getConditionValueToCheck(condition, items) {
    let valueToCheck = 0;

   if(condition.key === 'weight') { // check order total weight for all suborderitems
       valueToCheck = getTotalWeight(items);
   } else if(condition.key === 'subtotal') { // check order sub total for all suborderitems
       valueToCheck = getSubtotal(items);
   } else {
       console.error('ConditionKeyMissing');
   }
   return valueToCheck;
}

export function isConditionChecked(condition, items, exceptions = []) {
    console.log('isConditionChecked ::: Start', condition, items, exceptions);

    if(exceptions && exceptions.includes(condition.key)) {
        // console.log('isConditionChecked ::: Allowed by exceptions');
        return true;
    }

    const conditionValue = getConditionValue(condition);
    const valueToCheck = getConditionValueToCheck(condition, items);

    console.log('isConditionChecked ::: Check', condition.key, `${valueToCheck}${isConditionPercentValue(condition) ? '%' : ''} ${condition.limit === 'min' ? '>' : '<'}${condition.tolerance === 'exclusive' ? '' : '='} ${conditionValue}${isConditionPercentValue(condition) ? '%' : ''}`);
    if(condition.limit === 'min') {
        if(condition.tolerance === 'exclusive') {
            return valueToCheck > conditionValue;
        }
        // inclusive
        return valueToCheck >= conditionValue;
    }
    // max
    if(condition.tolerance === 'exclusive') {
        return valueToCheck < conditionValue;
    }
    // inclusive
    return valueToCheck <= conditionValue;
}

export function getConditionCheckPercentage(condition, items) {
    return (getConditionValueToCheck(condition, items) * 100) / getConditionValue(condition);
}

export function isAddressDepartmentAvailableForShippingFee(addressPostalCode, postalCode) {
    const jokerIndex = postalCode.indexOf('*') > 0 ? postalCode.indexOf('*') : postalCode.length;
    return addressPostalCode.substring(0, jokerIndex) !== postalCode.replace('*', '');
}

export function getShippingFeeAmount(store, address) {
    let fee = null;
    const shippingFee = getShippingFeeByAddress(store, address, getCartItems(store));
    if(shippingFee) {
        fee = shippingFee.amount;
    }
    return fee;
}

export function setShippingFees(shippingFees) {
    return {
        type: SET_SHIPPING_FEES,
        shippingFees,
    };
}

export function removeShippingFee(id) {
    return {
        type: REMOVE_SHIPPING_FEE,
        id,
    };
}
